import { render } from "./PositionClass.vue?vue&type=template&id=ff8c6324&scoped=true"
import script from "./PositionClass.vue?vue&type=script&lang=js"
export * from "./PositionClass.vue?vue&type=script&lang=js"

import "./PositionClass.vue?vue&type=style&index=0&id=ff8c6324&scoped=true&lang=scss"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8c6324"]])

export default __exports__